import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import MedicalCapabilityReports from './MedicalCapabilityReports';

export default class Safety extends React.Component {
	render() {
		let routeProps = this.props;
		return (
			<Switch>
				<Route path="/portal/safety/Medical Capability Reports" render={() => <MedicalCapabilityReports {... routeProps} />} />
			</Switch>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Safety/index.jsx